import { Component, OnInit, Input } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import * as colabInter from '../bd-colaboradores.interface';
import * as backInter from 'app/auth/auth-data.model';
import { saveAs } from 'file-saver';

import { DATOS_API } from 'app/auth/auth.datos';

import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';
import { lang_certificar } from 'app/idiomas/i18n/certificar/certificar.lang';
import { lang_modales } from 'app/idiomas/i18n/modales/modales.lang';

@Component({
  selector: 'app-descargar-plantilla',
  templateUrl: './descargar-plantilla.component.html',
  styleUrls: ['./descargar-plantilla.component.scss'],
  animations: fuseAnimations
})
export class DescargarPlantillaComponent implements OnInit {
  urlAssets = DATOS_API.urlAssets;
  @Input() productoID: any;
  @Input() fechaProducto:any;
  @Input() empresaId:any;
  instituto:any;
  columnasObligatorias:any;
  idiomaActual:any;

  constructor(
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService,
    private wizardService: WizardService
  ) {
    lang_certificar.forEach((locale) => {
            this._fuseTranslationLoaderService.loadTranslations(locale);
          });
    lang_modales.forEach((locale) => {
            this._fuseTranslationLoaderService.loadTranslations(locale);
          });

          //al cambiar el idioma, se cambia el valor de las variables de idiomas que se usan dentro del codigo
          this.translateSrv.onLangChange.subscribe(() => { this.traduceTextosTS(); });
  }

  ngOnInit() {
    console.log(this.fechaProducto);
    this.obtieneInstituto();
  }

  obtieneInstituto(){
    let institutoAct = this.wizardService.getInstituto();
    console.log(institutoAct);
    switch(institutoAct){
      case '1': case 'MX': this.instituto = 'MX'; break;
      case '2': case 'CAyC': this.instituto = 'CAyC'; this.columnasObligatorias = colabInter.COLUMNAS_OBLIGATORIAS_CAYC; break;
      case '3': case 'HK': this.instituto = 'HK'; this.columnasObligatorias = colabInter.COLUMNAS_OBLIGATORIAS_HK; break;
      case '4': case 'SGP': this.instituto = 'WLDWDE'; break;
      case '5': case 'TK': this.instituto = 'TK'; this.columnasObligatorias = colabInter.COLUMNAS_OBLIGATORIAS_TK; break;
      case '6': case 'FL': this.instituto = 'WLDWDE'; break;
      default: this.instituto = 'WLDWDE';
    }
    //se coloca aqui porque dentro de esa funcion se requiere tener el instituto
    this.traduceTextosTS();
  }
traduceTextosTS(){
    switch(this.translateSrv.currentLang){
      case 'es': this.idiomaActual = this.translateSrv.currentLang; break;
      case 'zh1': case 'zh2':
        if(this.instituto == 'HK'){
          this.idiomaActual = this.translateSrv.currentLang;
        }
        else{
          this.idiomaActual = 'en';
        }
      break;
      case 'tr':
        if(this.instituto == 'TK'){
          this.idiomaActual = this.translateSrv.currentLang;
        }
        else{
          this.idiomaActual = 'en';
        }
      break;
      default: this.idiomaActual = 'en';
    }
  }

  ModalArchivo(){
    let botonModalArchivo = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.IDIOMAS.ARCHIVOCOMFIRM';
    this.translateSrv.get(botonModalArchivo).subscribe((res: string) => { botonModalArchivo = res; });
    let rspEnterado = 'MODALES.ACCIONES.aceptar';
    this.translateSrv.get(rspEnterado).subscribe((res: string) => { rspEnterado = res; });
    Swal.fire({
      title: botonModalArchivo,
      icon: 'warning',
      showCancelButton: false,
      
      confirmButtonText: rspEnterado,

    });
  }

}
